import React from 'react';
import './Window.css';

const AchievementsWindow = ({ onClose, darkMode }) => {
  return (
    <div className={`window ${darkMode ? 'dark-mode' : ''}`}>
      <div className={`window-header ${darkMode ? 'dark-mode' : ''}`}>
        <span>Programs & Achievements</span>
        <button onClick={onClose}>X</button>
      </div>
      <div className={`window-body ${darkMode ? 'dark-mode' : ''}`}>
        <ul>
          <li>Toastmasters Public Speaking (Twice Finalist)</li>
          <li>ALC Literary Creation Contest (1st and 2nd Prizes)</li>
          <li>LCOY Youth Conference</li>
          <li>EMSI Next-Gen Hackathon, GDSC-EMSI Bootcamp, IDEH CTF</li>
        </ul>
      </div>
    </div>
  );
};

export default AchievementsWindow;
